<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("contracts") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div class="d-flex justify-end align-center mb-3">
            <ConfirmKeyDialog ref="confirmKeyDialogRef"></ConfirmKeyDialog>
            <CustomSelect
              dense
              solo
              custom-selection
              custom-item
              :value="visibleHeaders"
              multiple
              @input="setHeader"
              item-text="text"
              item-value="value"
              :items="headers"
              class="user_input no-margin mt-1 mr-4 ml-4"
            >
              <template #item="{ attrs, item }">
                <div
                  class="column-setting-title-wrap flex-grow-1"
                  @click="changeColumnSettings(item, attrs)"
                >
                  <BaseCheckbox
                    class="mr-2"
                    v-model="visibleHeaders"
                    :value="item.value"
                  />
                  <span class="v-list-item__title" style="width: 100%">{{
                    item.text
                  }}</span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ $t("columns") }}</span>
              </template>
            </CustomSelect>
          </div>
          <div class="mobile_simple overflow-auto">
            <TableWithFilter
              @change-header-order="onChangeHeaderOrder"
              @table-header-resized="onChangeSizeHeader"
              is-enabled-orderable-table
              isEnabledResizeTable
              child-key="items"
              :headers="filterableHeadersTable"
              :items="items"
              :options="tableOptions"
              fixed-header
              handlerValue="code"
              ref="tableWithFilterRef"
            >
              <template #filter.state>
                <div class="pa-1">
                  <VueSelect
                    @input="onChangeHandler"
                    clearable
                    v-model="contractListFilter.status"
                    :items="contractItemStatusList"
                  ></VueSelect>
                </div>
              </template>
              <template #filter.code>
                <div class="pa-1">
                  <CustomInputText
                    clearable
                    v-model="contractListFilter.code"
                    @input="onChangeHandler"
                    class="user_input no-margin"
                    type="text"
                  ></CustomInputText>
                </div>
              </template>
              <template #filter.conclusionDate>
                <div class="pa-1 d-flex align-center">
                  <span class="custom_input_label pt-1 pr-2">{{
                    $t("from")
                  }}</span>
                  <CustomDatePicker
                    :max="contractListFilter.toDate || new Date()"
                    @input="onChangeHandler"
                    clearable
                    v-model="contractListFilter.fromDate"
                    label=""
                    name="calendar"
                    class="user_input mr-2 data_item data_item_calendar"
                    icon="mdi-calendar-month small"
                  ></CustomDatePicker>
                  <span class="custom_input_label pt-1">{{ $t("to") }}</span>
                  <CustomDatePicker
                    :start-day="false"
                    @input="onChangeHandler"
                    clearable
                    :min="contractListFilter.fromDate"
                    :max="new Date()"
                    v-model="contractListFilter.toDate"
                    name="calendar_t"
                    color="#E3EBF3"
                    class="user_input data_input_tw ml-2 data_item"
                    icon="mdi-calendar-month small"
                  ></CustomDatePicker>
                </div>
              </template>

              <template #expandBtn="{ openHandler, item }">
                <TriangleBtn
                  :active="item.show"
                  :loading="item.loading"
                  @click="openHandler(item, getContractItems)"
                />
              </template>

              <!-- parent -->
              <template #item.conclusionDate="{ item }">{{
                item.conclusionDate | dateParse
              }}</template>
              <template #item.state="{ item }">
                <span class="font-weight-bold">{{
                  $t(`contractStatus.${item.state}`)
                }}</span>
              </template>
              <template #item.guessReceiveDate="{ item }">
                {{ item["guessReceiveDate"] | dateParse }}
              </template>

              <!-- child -->
              <template #child.action="{ item, child }">
                <VBtn @click="openViewDialog(child)" class="new_style">
                  <VueIcon icon="newEyeIcon"></VueIcon>
                </VBtn>
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="child.statusType === INITIATOR_STATUS_TYPE.WAITING"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="approve(child.id)"
                      ><VueIcon icon="newCheckIcon"></VueIcon
                    ></VBtn>
                  </template>
                  <span>{{ $t("matched") }}</span>
                </VTooltip>
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="child.statusType === INITIATOR_STATUS_TYPE.WAITING"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="openRejectContractDialog(child.id)"
                      ><VueIcon icon="newCancelIcon"></VueIcon
                    ></VBtn>
                  </template>
                  <span>{{ $t("notCompatible") }}</span>
                </VTooltip>
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="child.statusType === INITIATOR_STATUS_TYPE.WAITING"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="openPartAcceptedDialog(child.id)"
                    >
                      <vue-icon icon="newLoaderIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("partialAdmission") }}</span>
                </VTooltip>
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="child.statusType === INITIATOR_STATUS_TYPE.WAITING"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="openPartyAcceptedDialog(child.id)"
                    >
                      <vue-icon icon="newBuisnessChart" />
                    </VBtn>
                  </template>
                  <span>{{ $t("partyReception") }}</span>
                </VTooltip>
              </template>
              <template
                #child.numb="{
                  child,
                  /**
                   * @type Object
                   * @property {string} contractItemNumb
                   */
                }"
                >{{ child.contractItemNumb }}</template
              >
              <template #child.state="{ child }">
                <span
                  class="font-weight-bold"
                  :style="{
                    color:
                      child.statusType === INITIATOR_STATUS_TYPE.ACCEPTED
                        ? '#36C281'
                        : child.statusType === INITIATOR_STATUS_TYPE.REJECTED
                        ? '#ee6565'
                        : child.statusType ===
                          INITIATOR_STATUS_TYPE.PART_ACCEPTED
                        ? '#01617F'
                        : '#FDCC05',
                  }"
                  >{{
                    child.statusType !== INITIATOR_STATUS_TYPE.NEW
                      ? $t(`contractDivisionStatus.${child.statusType}`)
                      : ""
                  }}</span
                >
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child["itemGuessReceiveDate"] | dateParse }}
              </template>
              <template #child.unitType="{ child }">
                {{ child[`unit_type_name_${$i18n.locale}`] }}</template
              >
              <template #child.count="{ child }">{{
                child.contractItemCount | numberParse
              }}</template>
              <template #child.productAttrs="{ child }">
                {{ child.attrs && child.attrs.join(" || ") }}
              </template>
            </TableWithFilter>
            <VuePagination
              go-to
              @update:limit="
                (limit) => {
                  configuration.limit = limit;
                  configuration.page = 1;
                  changePage();
                }
              "
              v-model="configuration.page"
              :length="lastPage"
              @input="changePage"
              :limit="configuration.limit"
            />
          </div>
        </div>
      </div>
    </div>
    <DivisionShowItemDialog
      ref="divisionShowItemItemDialogRef"
    ></DivisionShowItemDialog>
    <RejectContractDialog
      ref="rejectContractDialogRef"
      @updateTableData="refreshPage"
    ></RejectContractDialog>
    <DivisionPartAcceptedDialog
      ref="divisionPartAcceptedDialogRef"
      @updateTableData="refreshPage()"
    ></DivisionPartAcceptedDialog>
    <DivisionPartyAcceptedDialog
      ref="partyAcceptedDialogRef"
      @updateTableData="refreshPage"
    ></DivisionPartyAcceptedDialog>
  </div>
</template>

<script>
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import gridTableMixin from "@/configuration/mixins/gridTableMixin";
import {
  dateFormat,
  TABLES,
  INITIATOR_STATUS_TYPE,
  contractStatus,
} from "@/utils/constants.js";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions.js";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import BaseCheckbox from "@/components/ui/BaseCheckbox";
import DivisionShowItemDialog from "@/components/division/DivisionShowItemDialog.vue";
import RejectContractDialog from "@/components/division/RejectContractDialog.vue";
import DivisionPartAcceptedDialog from "@/components/division/DivisionPartAcceptedDialog.vue";
import DivisionPartyAcceptedDialog from "@/components/division/DivisionPartyAcceptedDialog.vue";
import ConfirmKeyDialog from "@/components/ConfirmKeyDialog.vue";

const FilterDivisionContracts = {
  code: null,
  fromDate: null,
  groupId: null,
  productName: null,
  status: null,
  toDate: null,
  typeId: null,
};
export default {
  components: {
    VuePagination,
    TableWithFilter,
    TriangleBtn,
    VueSelect,
    BaseCheckbox,
    DivisionShowItemDialog,
    RejectContractDialog,
    DivisionPartAcceptedDialog,
    DivisionPartyAcceptedDialog,
    ConfirmKeyDialog,
  },
  data() {
    return {
      lastPage: 0,
      items: [],
      contractListFilter: {
        ...FilterDivisionContracts,
      },
      tableOptions: {
        sortBy: "conclusionDate",
        sortDirection: true,
      },
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    refreshPage() {
      this.getContracts();
      this.$refs.confirmKeyDialogRef.refreshList();
    },
    async changeColumnSettings(item, attr) {
      try {
        await this.$store.dispatch("updateColumn", {
          columnName: item.value,
          table: TABLES["Contract"].slug,
          visible: !trueSet(attr["aria-selected"]),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    openRejectContractDialog(childId) {
      const { rejectContractDialogRef } = this.$refs;
      if (rejectContractDialogRef) {
        rejectContractDialogRef.open(childId);
      }
    },
    openPartAcceptedDialog(userAgreementId) {
      const { divisionPartAcceptedDialogRef } = this.$refs;
      if (divisionPartAcceptedDialogRef) {
        divisionPartAcceptedDialogRef.open(userAgreementId);
      }
    },
    openPartyAcceptedDialog(userAgreementId) {
      const { partyAcceptedDialogRef } = this.$refs;
      if (partyAcceptedDialogRef) {
        partyAcceptedDialogRef.open(userAgreementId);
      }
    },
    setHeader(headers) {
      this.visibleHeaders = headers;
    },
    openViewDialog(child) {
      const { divisionShowItemItemDialogRef } = this.$refs;

      divisionShowItemItemDialogRef.open({
        ...child,
        unit_type_name: child[`unit_type_name_${this.$i18n.locale}`],
      });
    },
    async getContractItems(item) {
      const { page, limit } = this.configuration;
      let params = {
        forInitiator: true,
        contractId: item.id,
        page: page - 1,
        limit,
        ...this.tableOptions,
        ...this.contractListFilter,
      };
      const {
        data: { data },
      } = await this.$http.get("user-agreement/list", {
        params,
      });
      item.items = data;
    },
    async approve(contractItemId) {
      this.showLoading();
      try {
        await this.$http.post("user-agreement/accept", contractItemId, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.setSuccess({ text: this.$t("successfullySaved") });
        await this.getContracts();
        this.$refs.confirmKeyDialogRef.refreshList();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getContracts() {
      this.showLoading();
      try {
        const { page, limit } = this.configuration;
        let params = {
          page: page - 1,
          limit,
          ...this.tableOptions,
          ...this.contractListFilter,
        };
        const {
          data: { data, total },
        } = await this.$http.get("user-agreement/list-contract/by-initiator", {
          params,
        });
        this.items = data.map((item) => {
          item.show = false;
          item.loading = false;
          item.items = [];
          return item;
        });
        this.lastPage = makerPagination({ total: total, limit }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getContracts();
        this.clearLoading();
      }
    },
    onChangeHandler: debounce(function () {
      let filter = { ...this.contractListFilter };
      if (filter.fromDate)
        filter.fromDate = window.moment(filter.fromDate).format(dateFormat);
      if (filter.toDate)
        filter.toDate = window.moment(filter.toDate).format(dateFormat);
      this.getContractsByFilter();
    }, 500),
    async getContractsByFilter() {
      this.showLoading();
      this.configuration.page = 1;
      await this.getContracts();
      await this.$router
        .replace({
          query: { ...this.tableOptions, ...this.contractListFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    },
  },
  mixins: [gridTableMixin(TABLES.Contract.slug)],
  computed: {
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
    INITIATOR_STATUS_TYPE: () => INITIATOR_STATUS_TYPE,
    contractStatus: () => contractStatus,
    statusColor() {
      switch (this.contractItem.statusType) {
        case this.INITIATOR_STATUS_TYPE.ACCEPTED:
          return "#36C281";
        case this.INITIATOR_STATUS_TYPE.REJECTED:
          return "#ee6565";
        case this.INITIATOR_STATUS_TYPE.PART_ACCEPTED:
          return "#01456A";
        case this.INITIATOR_STATUS_TYPE.NEW:
          return "#FDCC05";
        default:
          return "#FDCC05";
      }
    },
    contractItemStatusList() {
      return Object.keys(INITIATOR_STATUS_TYPE)
        .filter((item) => {
          return item !== INITIATOR_STATUS_TYPE.NEW;
        })
        .map((item) => {
          return {
            name: this.$t(`contractDivisionStatus.${item}`),
            id: item,
          };
        });
    },
  },
  async mounted() {
    const { query } = this.$route;

    this.showLoading();
    await Promise.all([this.getColumns(), this.getContracts()]);
    this.clearLoading();

    if (query.showContract && this.items[0]) {
      await this.$refs.tableWithFilterRef.showChildHandler(
        this.items[0],
        this.getContractItems
      );
    }
  },
  async created() {
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (query.page) this.configuration.page = +query.page;
    this.tableOptions = tableOptions;
    this.contractListFilter = getQueryByKey(FilterDivisionContracts, query);
  },
};
</script>
